import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.749,4.572v6.86a3.325,3.325,0,0,1-3.32,3.32H4.569a3.325,3.325,0,0,1-3.32-3.32V4.572a3.325,3.325,0,0,1,3.32-3.32.75.75,0,1,1,0,1.5,1.814,1.814,0,0,0-1.82,1.82v6.86a1.82,1.82,0,0,0,1.82,1.82h6.86a1.827,1.827,0,0,0,1.82-1.82V4.572a1.82,1.82,0,0,0-1.82-1.82.75.75,0,0,1,0-1.5A3.325,3.325,0,0,1,14.749,4.572ZM4.539,7.412a.764.764,0,0,0-.02,1.06l2.94,3.05a.764.764,0,0,0,.54.23.747.747,0,0,0,.54-.23l2.94-3.05a.746.746,0,0,0-.02-1.06.764.764,0,0,0-1.06.02l-1.65,1.71V3a.75.75,0,1,0-1.5,0v6.14L5.6,7.432A.764.764,0,0,0,4.539,7.412Z';
const draw24px =
  'M15.41,12.46l-2.94,3a.74.74,0,0,1-.25.17.68.68,0,0,1-.29.06.72.72,0,0,1-.29-.06.85.85,0,0,1-.25-.17l-2.93-3a.75.75,0,0,1,0-1.06.76.76,0,0,1,1.06,0l1.64,1.71V6a.75.75,0,0,1,1.5,0v7.13l1.65-1.71a.76.76,0,0,1,1.06,0A.75.75,0,0,1,15.41,12.46ZM19.74,16V8A3.75,3.75,0,0,0,16,4.26a.75.75,0,0,0,0,1.5A2.25,2.25,0,0,1,18.24,8v8A2.25,2.25,0,0,1,16,18.26H8A2.25,2.25,0,0,1,5.74,16V8A2.25,2.25,0,0,1,8,5.76a.75.75,0,0,0,0-1.5A3.75,3.75,0,0,0,4.24,8v8A3.75,3.75,0,0,0,8,19.76h8A3.75,3.75,0,0,0,19.74,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowGenericDownIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowGenericDown')) as IconWithRender;

ArrowGenericDownIcon.displayName = 'ArrowGenericDownIcon';
ArrowGenericDownIcon.propTypes = Icon.propTypes;
ArrowGenericDownIcon.renderIcon = (props) => (
  <ArrowGenericDownIcon {...props} />
);
export default ArrowGenericDownIcon;
